var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTurtle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4185 5.5C14.4185 5.65787 14.4112 5.8133 14.397 5.96564C13.6432 5.66514 12.8252 5.5 11.9587 5.5C11.0922 5.5 10.2741 5.66514 9.52036 5.96564C9.50613 5.8133 9.49878 5.65787 9.49878 5.5C9.49878 3.567 10.6001 2 11.9587 2C13.3172 2 14.4185 3.567 14.4185 5.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9587 21C15.2192 21 17.8624 17.866 17.8624 14C17.8624 10.134 15.2192 7 11.9587 7C8.69811 7 6.05493 10.134 6.05493 14C6.05493 17.866 8.69811 21 11.9587 21Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07104 21.2002C5.07104 20.3294 5.41326 19.5399 5.96848 18.9629C6.59845 19.9782 7.42082 20.8372 8.38995 21.4544C8.03748 21.7927 7.56204 22.0002 7.03894 22.0002H5.8582C5.42346 22.0002 5.07104 21.642 5.07104 21.2002Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5273 21.4544C15.8798 21.7927 16.3552 22.0002 16.8783 22.0002H18.0591C18.4938 22.0002 18.8462 21.642 18.8462 21.2002C18.8462 20.3294 18.504 19.5399 17.9488 18.9629C17.3188 19.9782 16.4965 20.8372 15.5273 21.4544Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3517 13.549L20.6824 14.3379C21.2614 14.6812 22.0061 14.3589 21.9997 13.6858C21.9895 12.606 21.6675 11.5043 21.0097 10.5317C20.107 9.19695 18.7545 8.37497 17.3326 8.14709C18.5236 9.6025 19.2565 11.5215 19.3517 13.549Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99019 10.5318C3.8725 9.2272 5.18468 8.41246 6.57124 8.16357C5.37828 9.62906 4.64832 11.561 4.56333 13.5995L3.31752 14.3381C2.73848 14.6813 1.9938 14.359 2.00016 13.6859C2.01037 12.6061 2.33243 11.5044 2.99019 10.5318Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurtle);
export default __webpack_public_path__ + "static/media/turtle.72cbd21cb7fa5adbe9c12afc882249e7.svg";
export { ForwardRef as ReactComponent };